<template>
  <section class="content">
    <vue-headful title="QB-STATISTICS | Rollen"></vue-headful>
    <div class="box">
      <div class="box-header">
        <h3 class="box-title">Rollenmanagement</h3>
        <div class="box-tools">
          <div class="btn-group">
            <button type="button" class="btn btn-box-tool" data-widget="collapse"><i class="fa fa-minus"></i></button>
            <button type="button" class="btn btn-box-tool" data-widget="remove"><i class="fa fa-times"></i></button>
          </div>
        </div>
      </div>
      <div class="box-body">
        <div class="box-toolbar">
          <div class="btn-group">
            <button type="button" class="btn btn-sm btn-primary" data-toggle="modal" data-target="#addRoleModal"><i class="fa fa-plus mr-5"></i>Create Role</button>
          </div>
          <links-box></links-box>
        </div>
        <div class="row">
          <div class="col-sm-6"></div>
          <div class="col-sm-6">
            <div class="dataTables_filter form-inline">
              <label>Search:</label>
              <input type="search" class="form-control input-sm" placeholder aria-controls="users" v-model="filter">
            </div>
          </div>
        </div>
        <b-table :items="items" :fields="fields" :filter="filter">
          <template v-slot:cell(view)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'read')" class="btn btn-default btn-sm" data-toggle="modal" data-target="#editRoleModal" @click="updateRole(data.item.id)"><i class="fa fa-pencil mr-5"></i>Bearbeiten</button>
          </template>
          <template v-slot:cell(delete)="data">
            <button :disabled="checkIfDisabled(data.item.id, 'delete')" class="btn btn-danger btn-sm" data-toggle="modal" data-target="#deleteRoleModal" @click="deleteRole(data.item.id)"><i class="fa fa-trash mr-5"></i>Löschen</button>
          </template>
        </b-table>
      </div>
    </div>
    <div class="modal fade" id="addRoleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Create Role</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="form-group mt-5">
                <label for="roleName" class="control-label col-sm-4">Role Name:</label>
                <div class="col-sm-8">
                  <div id="createNewRole" class="input-group">
                    <input type="text" id="roleName" placeholder="Role Name" class="form-control" value="" v-model="newProp.name">
                    <span class="input-group-btn" v-if="!creating">
                      <button type="button" data-toggle="collapse" data-target="#roleCreateSettings" class="btn btn-default collapsed" :disabled="newProp.name === ''" @click="creating = true">Create</button>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-group collapse no-margin" id="roleCreateSettings">
              <template v-for="(actions, resource, index) in msOptions">
                <div class="panel">
                  <div class="panel-header">
                    <a data-toggle="collapse" data-parent="#roleCreateSettings" :href="`#createSet${index}`" aria-expanded="false" class="">
                      <i :class="icons[resource]"></i>{{resource}}
                    </a>
                  </div>
                  <div :id="`createSet${index}`" class="panel-collapse collapse" aria-expanded="false">
                    <div class="panel-body">
                      <template v-for="action in actions">
                        <resource-row :action="action" :resource="resource" @select="createProp($event, newProp)"></resource-row>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div id="createRoleFooter" class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeCreate"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button v-if="creating" class="btn btn-primary" @click="saveProp">Save<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="editRoleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Edit Role</h4>
          </div>
          <div class="nav-tabs-custom no-margin">
            <ul class="nav nav-tabs pull-right">
              <li :class="[enableEdit ? 'active' : '']" v-if="!checkIfDisabled(roleForUpdate.id, 'update')"><button @click="()=>{enableEdit = true}" type="button" class="btn"><i class="fa fa-pencil mr-5"></i>Edit Mode</button></li>
              <li :class="[enableEdit ? '' : 'active']"><button @click="()=>{enableEdit = false}" aria-expanded="true" type="button" class="btn"><i class="fa fa-eye mr-5"></i>View Mode</button></li>
            </ul>
          </div>
          <div class="modal-body">
            <div class="tab-content">
             <!-- <div v-if="enableEdit" class="alert alert-warning alert-dismissible">
                <button type="button" class="close" data-dismiss="alert" aria-hidden="true">×</button>
                <h4><i class="icon fa fa-warning mr-5"></i>Edit carefully!</h4>
                Mistakes will be punished with immediate execution ;)
              </div>-->
              <h4 class="tab-info">Role: {{roleForUpdate.name}}</h4>
              <!-- VIEW MODE -->
              <div class="tab-pane active">
                <div class="panel-group" id="roleViewSettings" v-if="roleForUpdate && roleForUpdate.id">
                  <template v-for="(actions, resource, index) in msOptions">
                    <div :class="['panel role', {active: roleForUpdate.permissions[resource]}]">
                      <div class="panel-header">
                        <a data-toggle="collapse" data-parent="#roleViewSettings" :href="`#viewSet${index}`" aria-expanded="false" class="collapsed">
                          <i :class="icons[resource]"></i>{{resource | capitalize}}
                        </a>
                      </div>
                      <div :id="`viewSet${index}`" class="panel-collapse collapse" aria-expanded="false">
                        <div class="panel-body">
                          <template v-for="action in actions">
                            <edit-role-row :editEnabled="enableEdit" :hasPermission="!checkIfDisabled(roleForUpdate.id, 'update')" :action="action" :permissions="getPermissions(resource, action)" :resource="resource" @select="updateProp($event, roleForUpdate)"></edit-role-row>
                          </template>
                        </div>
                      </div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeUpdate"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="button" @click="saveRoleUpdate" class="btn btn-primary">Save<i class="fa fa-save ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal modal-danger fade" id="deleteRoleModal" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <h4 class="modal-title">Delete Role</h4>
          </div>
          <div class="modal-body">
            <h3 class="text-center" v-if="items && roleForDelete !== ''">
              Are you sure you want to delete the role<br>"{{items.find(r => {return r.id === roleForDelete}).value}}"?
            </h3>
            <p class="text-center text-danger">
              <i class="fa fa-warning mr-5"></i>This action cannot be undone.
            </p>
          </div>
          <div class="modal-footer text-left">
            <button type="button" class="btn btn-outline pull-left" data-dismiss="modal" ref="closeDelete"><span class="fa fa-times mr-5"></span>Cancel</button>
            <button type="button" @click="onOk" class="btn btn-danger" data-dismiss="modal">Delete<i class="fa fa-trash ml-5"></i></button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import axios from 'axios'
  import Api from '@/services/Api'
  export default {
    name: "AdminEdit",
    data () {
      return {
        filter: '',
        fields: [
          {key: 'id', label: 'Role ID'},
          {key: 'value', label: 'Role name'},
          {key: 'view', label: 'Edit'},
          {key: 'delete', label: 'Delete'}
        ],
        creating: false,
        enableEdit: false,
        roleForDelete:'',
        display: false,
        userPermissions: this.$store.getters.permissions,
        roleForUpdate: {},
        showButton: false,
        msOptions: [],
        properties: [],
        selectedProp: '',
        selectedName: '',
        items: [],
        fullOptions: [],
        newProp: {},
        icons: {
          user: 'fa fa-user',
          role: 'fa fa-tasks',
          salesChannel: 'fa fa-sitemap',
          company: 'fa fa-building-o',
          userType: 'fa fa-address-book-o',
          module: 'fa fa-cubes',
          page: 'fa fa-file-text-o',
          store: 'fa fa-home',
          chart: 'fa fa-pie-chart'
        }
      }
    },
    methods: {
      getData () {
        axios.all([Api().get(`/frontend/permission/base`), Api().get(`/accounting/role/list`)])
          .then(axios.spread((...responses) => {
            this.msOptions = responses[0].data
            Object.keys(responses[0].data).forEach(d => {
              this.newProp[d] = false
            })
            this.items = responses[1].data
          })).catch(errors => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
        })
      },
      checkIfEmpty (resource) {
        console.log(resource)
      },
      updateRole (id) {
        Api().get(`/accounting/role?id=${id}`)
        .then(res => {
          this.display = true
          this.roleForUpdate = res.data
          /*Object.keys(this.roleForUpdate.permissions).forEach(p => {
            this.msOptions[p].forEach(a => {
              this.roleForUpdate.permissions[p][a] = this.roleForUpdate.permissions[p][a] || []
            })
          })
          this.roleForUpdate = {...this.roleForUpdate}*/
         /* this.$bvModal.show('editRole')*/
        }).catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      },
      onOk () {
        Api().delete(`/accounting/role?id=${this.roleForDelete}`)
        .then(res => {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Success!',
            text: 'Role Deleted Successfully'
          });
          Api().get(`/accounting/role/list`)
          .then(response => {
            this.items = response.data
            this.roleForDelete = ''
            this.$refs.closeDelete.click()
          }).catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
          })
        })
        .catch(error => {
          this.confirmOpen = false
        })
      },
      addToProps () {
        this.newProp.name = this.selectedName
        Object.keys(this.msOptions).forEach(k => {
          this.newProp[k] = {}
        })
        this.newProp.permissions = []
        this.properties.push(this.newProp)
        this.selectedName = ''
      },
      updateProp (prop, target) {
        if (!(prop.resource in target.permissions)) {
          target.permissions[prop.resource] = {}
        }
        target.permissions[prop.resource][prop.action] = prop.props
        target = {...target}
      },
      createProp (prop, target) {
        target.permissions = target.permissions || []
        prop.props.forEach(p => {
          if (!target.permissions.includes(p)) {
            target.permissions.push(p)
          }
        })
      },
      deleteRole (id) {
        this.roleForDelete = id
      },
      saveProp () {
        this.newProp.permissions = this.newProp.permissions.join(',')
        Api().post(`/accounting/role`, this.newProp)
        .then(response => {
          this.$notify({
            group: 'foo',
            type: 'success',
            title: 'Success!',
            text: 'Role Created Successfully'
          });
          Api().get(`/accounting/role/list`)
          .then(res => {
            this.newProp = {}
            this.$refs.closeCreate.click()
            this.items = res.data
            this.properties = []
          }).catch(error => {
            this.$notify({
              group: 'foo',
              type: 'error',
              title: 'Error',
              text: 'Es gab ein Fehler'
            });
          })
        })
        .catch(error => {
          this.$notify({
            group: 'foo',
            type: 'error',
            title: 'Error',
            text: 'Es gab ein Fehler'
          });
        })
      },
      saveRoleUpdate () {
        this.roleForUpdate.permissions = this.getPermissionsIDs(this.roleForUpdate.permissions)
        Api().put(`/accounting/role`, this.roleForUpdate)
          .then(res => {
            this.$notify({
              group: 'foo',
              type: 'success',
              title: 'Success!',
              text: 'Role Updated Successfully'
            });
            this.enableEdit = false
            this.$refs.closeUpdate.click()
            this.roleForUpdate = {}
          })
      },
      getPermissionsIDs (arr) {
        let retArr = []
        for (let r in arr) {
          for (let a in arr[r]) {
            arr[r][a].forEach(p => {
              if (!retArr.includes(p.id)) {
                retArr.push(p.id)
              }
            })
          }
        }
        return retArr.join(',')
      },
      checkIfDisabled (id, action) {
        if (action in this.userPermissions.role) {
          let a = this.userPermissions['role'][action].find(x => x.value === id || x.value === 'all')
          return typeof a === 'undefined'
        }
        return true
      },
      getPermissions (resource, action) {
        if (this.roleForUpdate.permissions[resource]) {
          return this.roleForUpdate.permissions[resource][action] || []
        }
        return []
      }
    },
    beforeCreate() {
        this.$store.dispatch('userHasPermission', {type: 'role', action: 'create', scope: 'all'})
        .then(res => {
          this.showButton = res
        })
    },
    mounted () {
      this.getData()
    },
    watch: {
      items () {}
    }
  }
</script>
<style>
  .nav-tabs .nav-link.active {
    border-color: #dee2e6 #dee2e6 #fff !important;
    color: white;
    background-color: #292a31;
    border-radius: 2px !important;
    border: 1px solid !important;
    border-bottom: #292a31 !important;
  }
  .nav-tabs .nav-item {
    margin-bottom: -3px !important;
  }
  .card-header {
    margin-bottom: 0;
    background-color: rgba(0,0,0,.03);
  }
  .card-header {
    background-color: grey;
    color: black ;
  }
  .nav.nav-tabs.card-header-tabs {
    border-bottom: 1px solid white;
  }
  div.dataTables_filter {
    text-align: right;
  }
  div.dataTables_filter label {
    font-weight: normal;
    white-space: nowrap;
    text-align: left;
  }
  div.dataTables_filter input {
    margin-left: 0.5em;
    display: inline-block;
    width: auto;
  }
</style>
